import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { getWorkspaceListingUrl, getWorkspaceUrl } from '@futrli/predict-next/workspaces/utils/route-utils';
import { ROUTES } from '@futrli/shared-services';
import {
  SecondaryNavbar,
  SecondaryNavbarMenuItem
} from '@futrli/ui-components/components/nav/secondary-navbar/secondary-navbar';

interface SettingsSubNavProps {
  hasUsersPermission?: boolean;
  onlyExternalOrgs: boolean;
  workspaceId: string;
  workspacesCount: number;
}

export const SettingsSubNav = ({
  workspaceId,
  onlyExternalOrgs,
  workspacesCount,
  hasUsersPermission = true
}: SettingsSubNavProps) => {
  const intl = useIntl();

  const leftMenuItems: SecondaryNavbarMenuItem[] = useMemo(() => {
    if (onlyExternalOrgs) {
      return [
        {
          id: 'consolidations',
          name: intl.formatMessage({ id: 'common.consolidations', defaultMessage: 'Consolidations' }),
          url: getWorkspaceListingUrl(workspaceId, 'consolidations')
        }
      ];
    }

    const items: SecondaryNavbarMenuItem[] = [
      {
        id: 'organisations',
        name: intl.formatMessage({ id: 'common.organisations', defaultMessage: 'Organisations' }),
        url: getWorkspaceListingUrl(workspaceId)
      }
    ];

    if (hasUsersPermission) {
      items.push({
        id: 'users',
        name: intl.formatMessage({ id: 'common.users', defaultMessage: 'Users' }),
        url: getWorkspaceUrl(workspaceId, 'users')
      });
    }

    return items;
  }, [onlyExternalOrgs, hasUsersPermission, intl, workspaceId]);

  const rightMenuItems: SecondaryNavbarMenuItem[] = useMemo(() => {
    const output: SecondaryNavbarMenuItem[] = [];
    if (workspacesCount > 1) {
      output.push({
        id: 'workspaces',
        name: intl.formatMessage({ id: 'common.workspaces', defaultMessage: 'Workspaces' }),
        url: ROUTES.WORKSPACES_ROUTE
      });
    }
    return output;
  }, [workspacesCount, intl]);

  return <SecondaryNavbar leftMenuItems={leftMenuItems} rightMenuItems={rightMenuItems} />;
};
